import { AtSymbolIcon } from "@heroicons/react/outline";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { logEvent } from "firebase/analytics";
import { useNavigate } from "react-router-dom";
import { Alert } from "../../Components/Alert";
import { Button } from "../../Components/Button";
import { registerUser, useAuthDispatch, useAuthState } from "../../Context";
import { analytics } from "../../firebase";
import FormLabel from "../../Components/FormLabel";

const EmailCodeSignUp = () => {
  const navigate = useNavigate();
  const [email, setemail] = useState("");
  const [referral, setreferral] = useState("");

  const dispatch = useAuthDispatch();
  const { register, loading, error } = useAuthState();

  const { t } = useTranslation();

  useEffect(() => {
    if (!register?.isSignUpComplete) {
      if (register.nextStep?.signUpStep === "CONFIRM_SIGN_UP") {
        localStorage.removeItem("lastUsedAuth");
        localStorage.removeItem("authProvider");
        navigate("/confirm", { state: { userEmail: email } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register]);

  const handleEmailChange = (event) => {
    setemail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    registerUser(dispatch, { email, referral });
    logEvent(analytics, "sign_up");
  };

  return (
    <div className="max-w-lg mx-auto">
      <form
        action="#"
        onSubmit={handleSubmit}
        className="bg-white p-8 mt-6 mb-0 space-y-4 rounded-lg shadow-sm"
      >
        <p className="text-lg font-medium">
          {t("Sign up for PajakInd account")}
        </p>

        {error ? (
          <Alert
            type="error"
            message={error?.message || "Error sign up your new account."}
            errors={error?.errors}
          />
        ) : null}

        <div>
          <label htmlFor="email" className="text-sm font-medium">
            {t("Email")}
          </label>

          <div className="relative mt-1">
            <input
              type="email"
              id="email"
              className="w-full p-4 pr-12 text-sm border-gray-200 rounded-lg shadow-sm focus:outline-none focus:ring-0 focus:border-blue-500"
              placeholder={t("Enter email")}
              value={email}
              onChange={handleEmailChange}
              required
            />

            <span className="absolute inset-y-0 inline-flex items-center right-4">
              <AtSymbolIcon className="w-5 h-5 text-gray-400" />
            </span>
          </div>
        </div>

        <div className="relative mt-1">
          <FormLabel htmlFor="referral" label={t("referralCode")} />
          <input
            type="text"
            name="referral"
            value={referral || ""}
            placeholder={t("referralCodePlaceholder")}
            onChange={(e) => {
              const sanitizedValue = e.target.value
                .replace(/[^a-zA-Z0-9]/g, "")
                .toUpperCase();
              setreferral(sanitizedValue);
            }}
            className="w-full p-4 pr-12 text-sm border-gray-200 rounded-lg shadow-sm focus:outline-none focus:ring-0 focus:border-blue-500 mt-1"
          />
        </div>

        <Button
          type="submit"
          className="w-full"
          loading={loading}
          disabled={loading}
          title={t("Sign up")}
        />

        <p className="text-sm text-center text-gray-500">
          <a className="underline" href="/login">
            {t("Log in")}
          </a>
        </p>

        <p className="text-sm text-center text-gray-500">
          <a className="underline" href="/confirm">
            {t("Confirm your account")}
          </a>
        </p>
      </form>
    </div>
  );
};

export default EmailCodeSignUp;
